module.exports = __WEBPACK_EXTERNAL_MODULE__mapbox_mapbox_gl_geocoder__;